/**
 * Convert BlockNumber to bigint
 *
 * @param {import('./BlockNumberType.js').BlockNumberType} blockNumber
 * @returns {bigint}
 */
export function toBigInt(blockNumber) {
	return blockNumber;
}
